import http from '@/api/http'

export default {
    getList(cb) {
        http.get('/api/cnt/list', cb);
    },
    getReportList(cb, request) {
        http.post('/api/cnt/supplement-list', cb, request);
    }
}